import * as route from "../../arc/routes.js";

export const apiGet = async (ent, key) => {
    ent = String.jet.to(ent);
    key = String.jet.to(key);

    const resp = await fetch(route.apiRaws + "/" + ent + (key ? `('${key}')` : ""), {
        headers: { 'Authorization': "Basic d2ViOmo0R1pjMXBrWlI4ZlNvSGFuSTJQRzhEY3lhNHd5WE8x" }
    });

    const data = await resp.json();
    if (!Object.jet.is(data)) { throw Error("API response is not an Object :("); }

    if (key) { return data; }

    if (!Array.isArray(data.value)) { throw Error("API response.value is not an Array :("); }
    
    return data.value;
}